import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './BrowseLookSwiperNewUI.css';
import { Navigation, Pagination, Parallax } from 'swiper/modules';
import { Box, Button, Card, Chip, Divider, Modal, Typography, Dialog } from '../utils/mui-imports';
// import InstagramEmbed from './InstagramEmbed';
import { InstagramEmbed } from 'react-social-media-embed';
import InstagramEmbedPermalink from './InstagramEmbedNew';

import Caption from './Caption';
// import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { FaArrowRight, FaChartLine, FaChevronLeft, FaExpand, FaUser } from 'react-icons/fa';
import { TrendingUpIcon } from '../utils/mui-imports';
import { useNavigate } from 'react-router-dom';
import { 
  WhatsAppIcon, 
  PinterestIcon, 
  ContentCopyIcon, 
  SettingsBackupRestoreIcon, 
  AutoAwesomeIcon, 
  ShoppingCartIcon, 
  ArrowBackIosIcon 
} from '../utils/mui-imports';
import ShowcaseLookCard from './ShowcaseLookCard';

export default function BrowseLookSwiper({ selectedTab, image_info, showAll }) {
  const isInfluencerTab = selectedTab.param === "featured_influencer";
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLook, setSelectedLook] = useState(null);
  const navigate = useNavigate() 
  const isMobile = window.innerWidth < 768
  

  const handleSlideClick = (item) => {
    setSelectedLook(item);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedLook(null);
  };


  return (
    <>
      <Swiper
        style={{
          '--swiper-navigation-color': '#fff',
          '--swiper-pagination-color': '#fff',
          height: '75dvh',
        }}
        speed={600}
        parallax={true}
        modules={[Parallax, Navigation, Pagination]}
        // navigation
        // pagination
        // spaceBetween={50}
        
        // className="mySwiper"
        slidesPerView={isInfluencerTab? 1: 2.25}
      >
        <Box
          sx={{
            mx: 2,
            position: 'absolute',
            bottom: "45%",
            px: 1,
            zIndex:2,
            
            py: 0.25,
            borderRadius: 24,
          }}
        >

         

          <Divider textAlign='left'
          sx={{
            // color:'blue'
          }}
          >

          <Chip 
          sx={{
            backgroundColor:'rgba(1,1,1,0.5)',
            backdropFilter:'blur(5px)'
          }}
          label=
          
          {
            <Box
            display={'flex'}
            flexDirection={"row"}
            alignItems={'center'}
            gap={2}
            >
          <Typography variant="body1" fontSize="1rem" color="white">
            {selectedTab.label} 
          </Typography>
          {showAll? null:<> <Divider orientation='vertical' flexItem /> 
          <Button
          endIcon={<FaArrowRight
          // size='small'
          />}
          onClick={()=>{navigate('/browse')}}
          sx={{fontSize:'0.5rem', color:'white'}}>View all</Button></>}
         
        </Box>  
        }
          />

          </Divider>
        

         
          
        </Box>

        {/* Parallax background only for non-influencer tabs */}
        {!isInfluencerTab && image_info.length > 1 && (
          <div
            slot="container-start"
            className="parallax-bg"
            style={{
              'background-image': `url(${image_info[1].image_url})`,
            }}
            data-swiper-parallax="-25%"
          ></div>
        )}

        {image_info && image_info.length > 0 ? (
          (showAll ? image_info : image_info.slice(0, 7)).map((item, index) => (
            <SwiperSlide  key={index} style={{ backgroundColor: 'none', margin:4 }}>
              {!isInfluencerTab?
               (
                <Box
                  onClick={() => handleSlideClick(item)}
                  sx={{ cursor: 'pointer' }}
                >
                  <Card
                    sx={{
                      position: 'absolute',
                      bottom: "10%",
                      // paddingX: 1,
                      backgroundColor: 'rgba(1,1,1,0)',
                      // boxShadow:'0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)'
                    }}
                  >
                    <Box sx={{ position: 'absolute', bottom: 0,
                      p:1,
                      backgroundColor:'rgba(1,1,1,0.5)',
                      backdropFilter:'blur(5px)',
                      width:'100%',
                      display:'flex',
                      flexDirection:'row',
                      justifyContent:'left'
                     }}>
                    <Typography
                      variant="body2"
                      color="white"
                      align="center"
                      // sx={{ mt: 1 }}
                    >
                      {item.name? item.name.slice(0, 17) : ""}...
                    </Typography>
                    </Box>
                    <img
                      style={{
                        // aspectRatio: 0.85,
                        borderRadius: 5,
                        objectFit: 'cover',
                        width: '100%',
                        backgroundColor: 'none',
                      }}
                      width="100%"
                      src={item.image_url}
                      alt={item.name}
                    />
                  </Card>
                </Box>
              ) :null }
            </SwiperSlide>
          ))
        ) : (
          <Box textAlign="center" py={8}>
            <Typography>No looks available</Typography>
          </Box>
        )}
      </Swiper>


      <Dialog
      fullScreen={isMobile? true : false}
      
      open={modalOpen} onClose={handleCloseModal}>

     
       
    
    
    <>
        <Box
        sx={{
          position:'absolute',
          zIndex:10,
          m:2

        }}
        >
            <Button

            onClick={()=>{setModalOpen(false)}}
            
            // startIcon={<FaChevronLeft/>}
            variant='outlined'
            color='primary'
            startIcon={<ArrowBackIosIcon/>}
           
            sx={{
              fontWeight:'bold',
               textTransform:'capitalize',
               backgroundColor: 'rgba(1,1,1,0.25)',
               backdropFilter: 'blur(5px)',
               color:'white',
               borderRadius:2,
               width:'auto',

            }}
            >Back</Button>
        </Box>

      
        
        <Box sx={{
          display:'flex',
          flexDirection:'column',
          justifyContent:'top',
          height:'100dvh', 
          // p: 4,
          overflowY:'scroll',
          gap:1,
          backgroundColor: 'white',
            position: 'relative',  }}>
          {selectedLook && (
              <ShowcaseLookCard 
              title={selectedLook.name}
              caption={selectedLook.description}
              image={selectedLook.image_url}
              lid={selectedLook.look_id}
             
              />
              
       
          )}
        </Box>
        
        </>
 
 
 
      
        {/* </Card> */}
      </Dialog>
    </>
  );
}

